import { DomainError } from "./errors";

/** Agrupamento pt-BR válido com vírgula decimal: "1.234,56", "12,5" (o ponto só aparece em grupos de 3). */
const WITH_COMMA = /^(?:[1-9]\d{0,2}(?:\.\d{3})+|\d+),\d+$/;
/** Sem vírgula, pontos em grupos de 3 depois de 1 a 3 dígitos (sem zero à esquerda) são milhar: "1.000" = mil. */
const THOUSANDS_ONLY = /^[1-9]\d{0,2}(?:\.\d{3})+$/;
/** Sem vírgula e fora do caso acima: inteiro ou um único ponto decimal ("1234.56", "1.5", "0.001"). */
const DOT_DECIMAL = /^\d+(?:\.\d+)?$/;

/**
 * Converte texto em inteiro escalado por 10^scale, sem usar float.
 * Regra pt-BR: com vírgula, ela é o decimal e o ponto é milhar; sem vírgula, "1.000" é mil e "1.5" é decimal.
 */
export function parseScaled(raw: string, scale: number, code: string): number {
  let s = raw.replace(/R\$|%|\s/g, "");
  const negative = s.startsWith("-");
  if (negative) s = s.slice(1);
  if (s.includes(",")) {
    if (!WITH_COMMA.test(s)) throw new DomainError(code, `valor inválido: ${raw}`);
    s = s.replace(/\./g, "").replace(",", ".");
  } else if (THOUSANDS_ONLY.test(s)) {
    s = s.replace(/\./g, "");
  } else if (!DOT_DECIMAL.test(s)) {
    throw new DomainError(code, `valor inválido: ${raw}`);
  }
  const [intPart = "", fracPart = ""] = s.split(".");
  if (fracPart.length > scale) throw new DomainError(code, `máximo de ${scale} casas: ${raw}`);
  const value = Number(intPart) * 10 ** scale + Number(fracPart.padEnd(scale, "0") || "0");
  if (!Number.isSafeInteger(value)) throw new DomainError(code, `valor fora do limite: ${raw}`);
  return negative && value !== 0 ? -value : value;
}

export function formatScaled(value: number, scale: number, minDecimals: number): string {
  if (!Number.isSafeInteger(value)) throw new DomainError("not_integer", `esperado inteiro: ${value}`);
  const negative = value < 0;
  const abs = Math.abs(value);
  const intPart = Math.floor(abs / 10 ** scale);
  let frac = String(abs % 10 ** scale).padStart(scale, "0");
  while (frac.length > minDecimals && frac.endsWith("0")) frac = frac.slice(0, -1);
  const intStr = intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${negative ? "-" : ""}${intStr}${frac ? "," + frac : ""}`;
}
